import type { WorkerNotification } from '../../messages/index.js'
import { NotificationIcon } from '../../messages/index.js'

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/**
 * What the worker was told, one card each: the message, the step it
 * suggests, and why it was sent - the message type and the score it was
 * built from. Shared by the current period's view and each month's panel
 * in the history, so a message reads the same wherever it is found.
 */
export function ActivityList({ notifications }: { notifications: readonly WorkerNotification[] }) {
  return (
    <div className="flex flex-col gap-1.5">
      {notifications.map((notification) => (
        <div key={notification.id} className="flex gap-2 items-start bg-white border border-marine/15 p-2">
          <NotificationIcon type={notification.type} size="sm" />
          <div className="min-w-0">
            <div className="text-[10.5px] text-ink-mid leading-relaxed">
              {notification.message}
              {/* Whether the worker has opened it, as the worker's own app records. */}
              <span className={`ml-1.5 text-[9px] font-bold uppercase tracking-wide ${notification.read ? 'text-ink-mid/60' : 'text-coral'}`}>{notification.read ? 'read' : 'unread'}</span>
            </div>
            {notification.action && <div className="text-[10.5px] text-ink leading-relaxed">{notification.action}</div>}
            {notification.basedOn && (
              <div className="text-[9px] text-ink-mid/70 mt-0.5">
                {notification.type.replace(/_/g, ' ')} · from the score computed {formatDateTime(notification.basedOn.computedAt)}
                {notification.expiresAt && ` · until ${formatDateTime(notification.expiresAt)}`}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
